// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from '@hey-api/client-fetch';
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { CreateCmsAttachmentData, CreateCmsAttachmentError, CreateCmsAttachmentResponse, GetCmsAttachmentData, CreateAttachmentData, CreateAttachmentError, CreateAttachmentResponse, ListAttachmentsByDatasourceData, GetAttachmentUrlData, GetAttachmentByKeyData, GetDatasourceData, FieldBoundaryByLocationData, LowResBoundariesByBboxData, HighResBoundariesByDetectedIdData, GetFarmsData, GetFarmsError, GetFarmsResponse, CreateFarmData, CreateFarmError, CreateFarmResponse, GetAllFarmsData, GetAllFarmsError, GetAllFarmsResponse, GetFarmByIdData, UpdateFarmData, UpdateFarmError, UpdateFarmResponse, DeleteFarmData, DeleteFarmError, DeleteFarmResponse, InviteToFarmData, InviteToFarmError, InviteToFarmResponse, ExportFieldBoundariesData, GetAnnumsForFarmData, PublicizeFarmData, PublicizeFarmError, PublicizeFarmResponse, PrivatizeFarmData, PrivatizeFarmError, PrivatizeFarmResponse, GetFieldImageryData, ListFieldUnusableMaskImageryData, GetFieldUnusableMaskImageryData, ListFieldProductImageryData, GetFieldProductImageryData, GetFieldDeltaFromNormImageryData, ListFieldAnomaliesImageryData, GetFieldAnomaliesImageryData, ListFieldColorizedBundleImageryData, GetFieldColorizedBundleImageryData, GetFieldNormMapImageryData, GetFieldVarianceMapImageryData, GetFieldsByFarmData, CreateFieldData, CreateFieldError, CreateFieldResponse, GetFieldData, UpdateFieldData, UpdateFieldError, UpdateFieldResponse, DeleteFieldData, DeleteFieldError, DeleteFieldResponse, FindCurrentFieldBoundaryData, FindFieldBoundaryData, GetAnnumsForFieldData, GetCombinedLayersForSourceData, GetSingleLayerForSourceData, ListDatesForLayerData, GetSingleLayerForSourceWithDateData, ListAllLayersForSourceData, GetInternalAllFarmsData, GetInternalAllFarmsError, GetInternalAllFarmsResponse, CreateInternalFarmData, CreateInternalFarmError, CreateInternalFarmResponse, GetInternalFarmByIdData, UpdateInternalFarmData, UpdateInternalFarmError, UpdateInternalFarmResponse, UpdateInternalFarmRolesData, UpdateInternalFarmRolesError, UpdateInternalFarmRolesResponse, UpdateInternalFieldForFarmData, UpdateInternalFieldForFarmError, UpdateInternalFieldForFarmResponse, GetInternalUserByIdData, EditUserInternalData, EditUserInternalError, EditUserInternalResponse, ListSectionsData, ListPublishedSectionsData, CreateOrUpdateSectionData, CreateOrUpdateSectionError, CreateOrUpdateSectionResponse, PublishSectionsData, PublishSectionsError, PublishSectionsResponse, ListFarmSectionsData, ListFarmPublishedSectionsData, CreateOrUpdateFarmSectionData, CreateOrUpdateFarmSectionError, CreateOrUpdateFarmSectionResponse, PublishFarmSectionsData, PublishFarmSectionsError, PublishFarmSectionsResponse, RegisterData, RegisterError, RegisterResponse, UpdateOnboardingFarmData, UpdateOnboardingFarmError, UpdateOnboardingFarmResponse, CreateOnboardingFieldData, CreateOnboardingFieldError, CreateOnboardingFieldResponse, GetOnboardingFieldByIdData, UpdateOnboardingFieldData, UpdateOnboardingFieldError, UpdateOnboardingFieldResponse, DeleteOnboardingFieldData, DeleteOnboardingFieldError, DeleteOnboardingFieldResponse, FindCurrentOnboardingFieldBoundaryData, CreateOnboardingAttachmentData, CreateOnboardingAttachmentError, CreateOnboardingAttachmentResponse, OnboardingFieldBoundaryByLocationData, OnboardingLowResBoundariesByBboxData, OnboardingHighResBoundariesByDetectedIdData, ResendEmailVerificationError, ResendEmailVerificationResponse, GetPublishedSystemContentData, UpdateSystemContentData, UpdateSystemContentError, UpdateSystemContentResponse, GetDraftSystemContentData, PublishSystemContentData, PublishSystemContentError, PublishSystemContentResponse, GetTileData, RegisterWithoutFarmError, RegisterWithoutFarmResponse, GetUserByIdData, EditUserData, EditUserError, EditUserResponse, DeleteUserData, DeleteUserError, DeleteUserResponse, GetAllUsersData, GetAllUsersError, GetAllUsersResponse, CreateUserData, CreateUserError, CreateUserResponse, ChangeUserPasswordData, ChangeUserPasswordError, ChangeUserPasswordResponse } from '../types.gen';
import { client, createCmsAttachment, getCmsAttachment, createAttachment, listAttachmentsByDatasource, getAttachmentUrl, getAttachmentByKey, getDatasources, getDatasource, fieldBoundaryByLocation, lowResBoundariesByBbox, highResBoundariesByDetectedId, getFarms, createFarm, getAllFarms, getFarmById, updateFarm, deleteFarm, inviteToFarm, exportFieldBoundaries, getAnnumsForFarm, publicizeFarm, privatizeFarm, getFieldImagery, listFieldUnusableMaskImagery, getFieldUnusableMaskImagery, listFieldProductImagery, getFieldProductImagery, getFieldDeltaFromNormImagery, listFieldAnomaliesImagery, getFieldAnomaliesImagery, listFieldColorizedBundleImagery, getFieldColorizedBundleImagery, getFieldNormMapImagery, getFieldVarianceMapImagery, getFieldsByFarm, createField, getField, updateField, deleteField, findCurrentFieldBoundary, findFieldBoundary, getAnnumsForField, getCombinedLayersForSource, getSingleLayerForSource, listDatesForLayer, getSingleLayerForSourceWithDate, listAllLayersForSource, getInternalAllFarms, createInternalFarm, getInternalAnnumsForAllFarms, getInternalFarmById, updateInternalFarm, updateInternalFarmRoles, updateInternalFieldForFarm, getInternalUserById, editUserInternal, listSections, listPublishedSections, createOrUpdateSection, publishSections, listFarmSections, listFarmPublishedSections, createOrUpdateFarmSection, publishFarmSections, register, getOnboardingFarm, updateOnboardingFarm, getOnboardingFields, createOnboardingField, getOnboardingFieldById, updateOnboardingField, deleteOnboardingField, findCurrentOnboardingFieldBoundary, createOnboardingAttachment, onboardingFieldBoundaryByLocation, onboardingLowResBoundariesByBbox, onboardingHighResBoundariesByDetectedId, resendEmailVerification, getPublishedSystemContent, updateSystemContent, getDraftSystemContent, publishSystemContent, getTile, registerWithoutFarm, getAccessToken, getUserById, editUser, deleteUser, getAllUsers, createUser, changeUserPassword, getMyUser } from '../services.gen';

type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): QueryKey<TOptions>[0] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return params;
};

export const createCmsAttachmentQueryKey = (options: Options<CreateCmsAttachmentData>) => [
    createQueryKey('createCmsAttachment', options)
];

export const createCmsAttachmentOptions = (options: Options<CreateCmsAttachmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCmsAttachment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCmsAttachmentQueryKey(options)
    });
};

export const createCmsAttachmentMutation = (options?: Partial<Options<CreateCmsAttachmentData>>) => {
    const mutationOptions: UseMutationOptions<CreateCmsAttachmentResponse, CreateCmsAttachmentError, Options<CreateCmsAttachmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCmsAttachment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCmsAttachmentQueryKey = (options: Options<GetCmsAttachmentData>) => [
    createQueryKey('getCmsAttachment', options)
];

export const getCmsAttachmentOptions = (options: Options<GetCmsAttachmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCmsAttachment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCmsAttachmentQueryKey(options)
    });
};

export const createAttachmentQueryKey = (options: Options<CreateAttachmentData>) => [
    createQueryKey('createAttachment', options)
];

export const createAttachmentOptions = (options: Options<CreateAttachmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAttachment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAttachmentQueryKey(options)
    });
};

export const createAttachmentMutation = (options?: Partial<Options<CreateAttachmentData>>) => {
    const mutationOptions: UseMutationOptions<CreateAttachmentResponse, CreateAttachmentError, Options<CreateAttachmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createAttachment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAttachmentsByDatasourceQueryKey = (options: Options<ListAttachmentsByDatasourceData>) => [
    createQueryKey('listAttachmentsByDatasource', options)
];

export const listAttachmentsByDatasourceOptions = (options: Options<ListAttachmentsByDatasourceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAttachmentsByDatasource({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAttachmentsByDatasourceQueryKey(options)
    });
};

export const getAttachmentUrlQueryKey = (options: Options<GetAttachmentUrlData>) => [
    createQueryKey('getAttachmentUrl', options)
];

export const getAttachmentUrlOptions = (options: Options<GetAttachmentUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttachmentUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttachmentUrlQueryKey(options)
    });
};

export const getAttachmentByKeyQueryKey = (options: Options<GetAttachmentByKeyData>) => [
    createQueryKey('getAttachmentByKey', options)
];

export const getAttachmentByKeyOptions = (options: Options<GetAttachmentByKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttachmentByKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttachmentByKeyQueryKey(options)
    });
};

export const getDatasourcesQueryKey = (options?: Options) => [
    createQueryKey('getDatasources', options)
];

export const getDatasourcesOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDatasources({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDatasourcesQueryKey(options)
    });
};

export const getDatasourceQueryKey = (options: Options<GetDatasourceData>) => [
    createQueryKey('getDatasource', options)
];

export const getDatasourceOptions = (options: Options<GetDatasourceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDatasource({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDatasourceQueryKey(options)
    });
};

export const fieldBoundaryByLocationQueryKey = (options: Options<FieldBoundaryByLocationData>) => [
    createQueryKey('fieldBoundaryByLocation', options)
];

export const fieldBoundaryByLocationOptions = (options: Options<FieldBoundaryByLocationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fieldBoundaryByLocation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: fieldBoundaryByLocationQueryKey(options)
    });
};

export const lowResBoundariesByBboxQueryKey = (options: Options<LowResBoundariesByBboxData>) => [
    createQueryKey('lowResBoundariesByBbox', options)
];

export const lowResBoundariesByBboxOptions = (options: Options<LowResBoundariesByBboxData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lowResBoundariesByBbox({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: lowResBoundariesByBboxQueryKey(options)
    });
};

export const highResBoundariesByDetectedIdQueryKey = (options: Options<HighResBoundariesByDetectedIdData>) => [
    createQueryKey('highResBoundariesByDetectedId', options)
];

export const highResBoundariesByDetectedIdOptions = (options: Options<HighResBoundariesByDetectedIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await highResBoundariesByDetectedId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: highResBoundariesByDetectedIdQueryKey(options)
    });
};

export const getFarmsQueryKey = (options?: Options<GetFarmsData>) => [
    createQueryKey('getFarms', options)
];

export const getFarmsOptions = (options?: Options<GetFarmsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFarms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFarmsQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = queryKey[0];
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query
        };
    }
    return params as unknown as typeof page;
};

export const getFarmsInfiniteQueryKey = (options?: Options<GetFarmsData>): QueryKey<Options<GetFarmsData>> => [
    createQueryKey('getFarms', options, true)
];

export const getFarmsInfiniteOptions = (options?: Options<GetFarmsData>) => {
    return infiniteQueryOptions<GetFarmsResponse, GetFarmsError, InfiniteData<GetFarmsResponse>, QueryKey<Options<GetFarmsData>>, unknown | Pick<QueryKey<Options<GetFarmsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetFarmsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getFarms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFarmsInfiniteQueryKey(options)
    });
};

export const createFarmQueryKey = (options: Options<CreateFarmData>) => [
    createQueryKey('createFarm', options)
];

export const createFarmOptions = (options: Options<CreateFarmData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createFarmQueryKey(options)
    });
};

export const createFarmMutation = (options?: Partial<Options<CreateFarmData>>) => {
    const mutationOptions: UseMutationOptions<CreateFarmResponse, CreateFarmError, Options<CreateFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllFarmsQueryKey = (options?: Options<GetAllFarmsData>) => [
    createQueryKey('getAllFarms', options)
];

export const getAllFarmsOptions = (options?: Options<GetAllFarmsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllFarms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllFarmsQueryKey(options)
    });
};

export const getAllFarmsInfiniteQueryKey = (options?: Options<GetAllFarmsData>): QueryKey<Options<GetAllFarmsData>> => [
    createQueryKey('getAllFarms', options, true)
];

export const getAllFarmsInfiniteOptions = (options?: Options<GetAllFarmsData>) => {
    return infiniteQueryOptions<GetAllFarmsResponse, GetAllFarmsError, InfiniteData<GetAllFarmsResponse>, QueryKey<Options<GetAllFarmsData>>, unknown | Pick<QueryKey<Options<GetAllFarmsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllFarmsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllFarms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllFarmsInfiniteQueryKey(options)
    });
};

export const getFarmByIdQueryKey = (options: Options<GetFarmByIdData>) => [
    createQueryKey('getFarmById', options)
];

export const getFarmByIdOptions = (options: Options<GetFarmByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFarmById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFarmByIdQueryKey(options)
    });
};

export const updateFarmMutation = (options?: Partial<Options<UpdateFarmData>>) => {
    const mutationOptions: UseMutationOptions<UpdateFarmResponse, UpdateFarmError, Options<UpdateFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteFarmMutation = (options?: Partial<Options<DeleteFarmData>>) => {
    const mutationOptions: UseMutationOptions<DeleteFarmResponse, DeleteFarmError, Options<DeleteFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const inviteToFarmQueryKey = (options: Options<InviteToFarmData>) => [
    createQueryKey('inviteToFarm', options)
];

export const inviteToFarmOptions = (options: Options<InviteToFarmData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await inviteToFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: inviteToFarmQueryKey(options)
    });
};

export const inviteToFarmMutation = (options?: Partial<Options<InviteToFarmData>>) => {
    const mutationOptions: UseMutationOptions<InviteToFarmResponse, InviteToFarmError, Options<InviteToFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await inviteToFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportFieldBoundariesQueryKey = (options: Options<ExportFieldBoundariesData>) => [
    createQueryKey('exportFieldBoundaries', options)
];

export const exportFieldBoundariesOptions = (options: Options<ExportFieldBoundariesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportFieldBoundaries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportFieldBoundariesQueryKey(options)
    });
};

export const getAnnumsForFarmQueryKey = (options: Options<GetAnnumsForFarmData>) => [
    createQueryKey('getAnnumsForFarm', options)
];

export const getAnnumsForFarmOptions = (options: Options<GetAnnumsForFarmData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAnnumsForFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAnnumsForFarmQueryKey(options)
    });
};

export const publicizeFarmMutation = (options?: Partial<Options<PublicizeFarmData>>) => {
    const mutationOptions: UseMutationOptions<PublicizeFarmResponse, PublicizeFarmError, Options<PublicizeFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await publicizeFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const privatizeFarmMutation = (options?: Partial<Options<PrivatizeFarmData>>) => {
    const mutationOptions: UseMutationOptions<PrivatizeFarmResponse, PrivatizeFarmError, Options<PrivatizeFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await privatizeFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFieldImageryQueryKey = (options: Options<GetFieldImageryData>) => [
    createQueryKey('getFieldImagery', options)
];

export const getFieldImageryOptions = (options: Options<GetFieldImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldImageryQueryKey(options)
    });
};

export const listFieldUnusableMaskImageryQueryKey = (options: Options<ListFieldUnusableMaskImageryData>) => [
    createQueryKey('listFieldUnusableMaskImagery', options)
];

export const listFieldUnusableMaskImageryOptions = (options: Options<ListFieldUnusableMaskImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFieldUnusableMaskImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFieldUnusableMaskImageryQueryKey(options)
    });
};

export const getFieldUnusableMaskImageryQueryKey = (options: Options<GetFieldUnusableMaskImageryData>) => [
    createQueryKey('getFieldUnusableMaskImagery', options)
];

export const getFieldUnusableMaskImageryOptions = (options: Options<GetFieldUnusableMaskImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldUnusableMaskImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldUnusableMaskImageryQueryKey(options)
    });
};

export const listFieldProductImageryQueryKey = (options: Options<ListFieldProductImageryData>) => [
    createQueryKey('listFieldProductImagery', options)
];

export const listFieldProductImageryOptions = (options: Options<ListFieldProductImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFieldProductImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFieldProductImageryQueryKey(options)
    });
};

export const getFieldProductImageryQueryKey = (options: Options<GetFieldProductImageryData>) => [
    createQueryKey('getFieldProductImagery', options)
];

export const getFieldProductImageryOptions = (options: Options<GetFieldProductImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldProductImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldProductImageryQueryKey(options)
    });
};

export const getFieldDeltaFromNormImageryQueryKey = (options: Options<GetFieldDeltaFromNormImageryData>) => [
    createQueryKey('getFieldDeltaFromNormImagery', options)
];

export const getFieldDeltaFromNormImageryOptions = (options: Options<GetFieldDeltaFromNormImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldDeltaFromNormImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldDeltaFromNormImageryQueryKey(options)
    });
};

export const listFieldAnomaliesImageryQueryKey = (options: Options<ListFieldAnomaliesImageryData>) => [
    createQueryKey('listFieldAnomaliesImagery', options)
];

export const listFieldAnomaliesImageryOptions = (options: Options<ListFieldAnomaliesImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFieldAnomaliesImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFieldAnomaliesImageryQueryKey(options)
    });
};

export const getFieldAnomaliesImageryQueryKey = (options: Options<GetFieldAnomaliesImageryData>) => [
    createQueryKey('getFieldAnomaliesImagery', options)
];

export const getFieldAnomaliesImageryOptions = (options: Options<GetFieldAnomaliesImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldAnomaliesImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldAnomaliesImageryQueryKey(options)
    });
};

export const listFieldColorizedBundleImageryQueryKey = (options: Options<ListFieldColorizedBundleImageryData>) => [
    createQueryKey('listFieldColorizedBundleImagery', options)
];

export const listFieldColorizedBundleImageryOptions = (options: Options<ListFieldColorizedBundleImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFieldColorizedBundleImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFieldColorizedBundleImageryQueryKey(options)
    });
};

export const getFieldColorizedBundleImageryQueryKey = (options: Options<GetFieldColorizedBundleImageryData>) => [
    createQueryKey('getFieldColorizedBundleImagery', options)
];

export const getFieldColorizedBundleImageryOptions = (options: Options<GetFieldColorizedBundleImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldColorizedBundleImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldColorizedBundleImageryQueryKey(options)
    });
};

export const getFieldNormMapImageryQueryKey = (options: Options<GetFieldNormMapImageryData>) => [
    createQueryKey('getFieldNormMapImagery', options)
];

export const getFieldNormMapImageryOptions = (options: Options<GetFieldNormMapImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldNormMapImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldNormMapImageryQueryKey(options)
    });
};

export const getFieldVarianceMapImageryQueryKey = (options: Options<GetFieldVarianceMapImageryData>) => [
    createQueryKey('getFieldVarianceMapImagery', options)
];

export const getFieldVarianceMapImageryOptions = (options: Options<GetFieldVarianceMapImageryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldVarianceMapImagery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldVarianceMapImageryQueryKey(options)
    });
};

export const getFieldsByFarmQueryKey = (options: Options<GetFieldsByFarmData>) => [
    createQueryKey('getFieldsByFarm', options)
];

export const getFieldsByFarmOptions = (options: Options<GetFieldsByFarmData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldsByFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldsByFarmQueryKey(options)
    });
};

export const createFieldQueryKey = (options: Options<CreateFieldData>) => [
    createQueryKey('createField', options)
];

export const createFieldOptions = (options: Options<CreateFieldData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createField({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createFieldQueryKey(options)
    });
};

export const createFieldMutation = (options?: Partial<Options<CreateFieldData>>) => {
    const mutationOptions: UseMutationOptions<CreateFieldResponse, CreateFieldError, Options<CreateFieldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createField({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFieldQueryKey = (options: Options<GetFieldData>) => [
    createQueryKey('getField', options)
];

export const getFieldOptions = (options: Options<GetFieldData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getField({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFieldQueryKey(options)
    });
};

export const updateFieldMutation = (options?: Partial<Options<UpdateFieldData>>) => {
    const mutationOptions: UseMutationOptions<UpdateFieldResponse, UpdateFieldError, Options<UpdateFieldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateField({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteFieldMutation = (options?: Partial<Options<DeleteFieldData>>) => {
    const mutationOptions: UseMutationOptions<DeleteFieldResponse, DeleteFieldError, Options<DeleteFieldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteField({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const findCurrentFieldBoundaryQueryKey = (options: Options<FindCurrentFieldBoundaryData>) => [
    createQueryKey('findCurrentFieldBoundary', options)
];

export const findCurrentFieldBoundaryOptions = (options: Options<FindCurrentFieldBoundaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await findCurrentFieldBoundary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findCurrentFieldBoundaryQueryKey(options)
    });
};

export const findFieldBoundaryQueryKey = (options: Options<FindFieldBoundaryData>) => [
    createQueryKey('findFieldBoundary', options)
];

export const findFieldBoundaryOptions = (options: Options<FindFieldBoundaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await findFieldBoundary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findFieldBoundaryQueryKey(options)
    });
};

export const getAnnumsForFieldQueryKey = (options: Options<GetAnnumsForFieldData>) => [
    createQueryKey('getAnnumsForField', options)
];

export const getAnnumsForFieldOptions = (options: Options<GetAnnumsForFieldData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAnnumsForField({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAnnumsForFieldQueryKey(options)
    });
};

export const getCombinedLayersForSourceQueryKey = (options: Options<GetCombinedLayersForSourceData>) => [
    createQueryKey('getCombinedLayersForSource', options)
];

export const getCombinedLayersForSourceOptions = (options: Options<GetCombinedLayersForSourceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCombinedLayersForSource({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCombinedLayersForSourceQueryKey(options)
    });
};

export const getSingleLayerForSourceQueryKey = (options: Options<GetSingleLayerForSourceData>) => [
    createQueryKey('getSingleLayerForSource', options)
];

export const getSingleLayerForSourceOptions = (options: Options<GetSingleLayerForSourceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSingleLayerForSource({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSingleLayerForSourceQueryKey(options)
    });
};

export const listDatesForLayerQueryKey = (options: Options<ListDatesForLayerData>) => [
    createQueryKey('listDatesForLayer', options)
];

export const listDatesForLayerOptions = (options: Options<ListDatesForLayerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listDatesForLayer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDatesForLayerQueryKey(options)
    });
};

export const getSingleLayerForSourceWithDateQueryKey = (options: Options<GetSingleLayerForSourceWithDateData>) => [
    createQueryKey('getSingleLayerForSourceWithDate', options)
];

export const getSingleLayerForSourceWithDateOptions = (options: Options<GetSingleLayerForSourceWithDateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSingleLayerForSourceWithDate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSingleLayerForSourceWithDateQueryKey(options)
    });
};

export const listAllLayersForSourceQueryKey = (options: Options<ListAllLayersForSourceData>) => [
    createQueryKey('listAllLayersForSource', options)
];

export const listAllLayersForSourceOptions = (options: Options<ListAllLayersForSourceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAllLayersForSource({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAllLayersForSourceQueryKey(options)
    });
};

export const getInternalAllFarmsQueryKey = (options?: Options<GetInternalAllFarmsData>) => [
    createQueryKey('getInternalAllFarms', options)
];

export const getInternalAllFarmsOptions = (options?: Options<GetInternalAllFarmsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInternalAllFarms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInternalAllFarmsQueryKey(options)
    });
};

export const getInternalAllFarmsInfiniteQueryKey = (options?: Options<GetInternalAllFarmsData>): QueryKey<Options<GetInternalAllFarmsData>> => [
    createQueryKey('getInternalAllFarms', options, true)
];

export const getInternalAllFarmsInfiniteOptions = (options?: Options<GetInternalAllFarmsData>) => {
    return infiniteQueryOptions<GetInternalAllFarmsResponse, GetInternalAllFarmsError, InfiniteData<GetInternalAllFarmsResponse>, QueryKey<Options<GetInternalAllFarmsData>>, unknown | Pick<QueryKey<Options<GetInternalAllFarmsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetInternalAllFarmsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getInternalAllFarms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInternalAllFarmsInfiniteQueryKey(options)
    });
};

export const createInternalFarmQueryKey = (options: Options<CreateInternalFarmData>) => [
    createQueryKey('createInternalFarm', options)
];

export const createInternalFarmOptions = (options: Options<CreateInternalFarmData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createInternalFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createInternalFarmQueryKey(options)
    });
};

export const createInternalFarmMutation = (options?: Partial<Options<CreateInternalFarmData>>) => {
    const mutationOptions: UseMutationOptions<CreateInternalFarmResponse, CreateInternalFarmError, Options<CreateInternalFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createInternalFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInternalAnnumsForAllFarmsQueryKey = (options?: Options) => [
    createQueryKey('getInternalAnnumsForAllFarms', options)
];

export const getInternalAnnumsForAllFarmsOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInternalAnnumsForAllFarms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInternalAnnumsForAllFarmsQueryKey(options)
    });
};

export const getInternalFarmByIdQueryKey = (options: Options<GetInternalFarmByIdData>) => [
    createQueryKey('getInternalFarmById', options)
];

export const getInternalFarmByIdOptions = (options: Options<GetInternalFarmByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInternalFarmById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInternalFarmByIdQueryKey(options)
    });
};

export const updateInternalFarmMutation = (options?: Partial<Options<UpdateInternalFarmData>>) => {
    const mutationOptions: UseMutationOptions<UpdateInternalFarmResponse, UpdateInternalFarmError, Options<UpdateInternalFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateInternalFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateInternalFarmRolesMutation = (options?: Partial<Options<UpdateInternalFarmRolesData>>) => {
    const mutationOptions: UseMutationOptions<UpdateInternalFarmRolesResponse, UpdateInternalFarmRolesError, Options<UpdateInternalFarmRolesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateInternalFarmRoles({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateInternalFieldForFarmMutation = (options?: Partial<Options<UpdateInternalFieldForFarmData>>) => {
    const mutationOptions: UseMutationOptions<UpdateInternalFieldForFarmResponse, UpdateInternalFieldForFarmError, Options<UpdateInternalFieldForFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateInternalFieldForFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInternalUserByIdQueryKey = (options: Options<GetInternalUserByIdData>) => [
    createQueryKey('getInternalUserById', options)
];

export const getInternalUserByIdOptions = (options: Options<GetInternalUserByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInternalUserById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInternalUserByIdQueryKey(options)
    });
};

export const editUserInternalMutation = (options?: Partial<Options<EditUserInternalData>>) => {
    const mutationOptions: UseMutationOptions<EditUserInternalResponse, EditUserInternalError, Options<EditUserInternalData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await editUserInternal({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSectionsQueryKey = (options: Options<ListSectionsData>) => [
    createQueryKey('listSections', options)
];

export const listSectionsOptions = (options: Options<ListSectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSectionsQueryKey(options)
    });
};

export const listPublishedSectionsQueryKey = (options: Options<ListPublishedSectionsData>) => [
    createQueryKey('listPublishedSections', options)
];

export const listPublishedSectionsOptions = (options: Options<ListPublishedSectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublishedSections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublishedSectionsQueryKey(options)
    });
};

export const createOrUpdateSectionMutation = (options?: Partial<Options<CreateOrUpdateSectionData>>) => {
    const mutationOptions: UseMutationOptions<CreateOrUpdateSectionResponse, CreateOrUpdateSectionError, Options<CreateOrUpdateSectionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOrUpdateSection({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishSectionsMutation = (options?: Partial<Options<PublishSectionsData>>) => {
    const mutationOptions: UseMutationOptions<PublishSectionsResponse, PublishSectionsError, Options<PublishSectionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await publishSections({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFarmSectionsQueryKey = (options: Options<ListFarmSectionsData>) => [
    createQueryKey('listFarmSections', options)
];

export const listFarmSectionsOptions = (options: Options<ListFarmSectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFarmSections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFarmSectionsQueryKey(options)
    });
};

export const listFarmPublishedSectionsQueryKey = (options: Options<ListFarmPublishedSectionsData>) => [
    createQueryKey('listFarmPublishedSections', options)
];

export const listFarmPublishedSectionsOptions = (options: Options<ListFarmPublishedSectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFarmPublishedSections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFarmPublishedSectionsQueryKey(options)
    });
};

export const createOrUpdateFarmSectionMutation = (options?: Partial<Options<CreateOrUpdateFarmSectionData>>) => {
    const mutationOptions: UseMutationOptions<CreateOrUpdateFarmSectionResponse, CreateOrUpdateFarmSectionError, Options<CreateOrUpdateFarmSectionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOrUpdateFarmSection({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishFarmSectionsMutation = (options?: Partial<Options<PublishFarmSectionsData>>) => {
    const mutationOptions: UseMutationOptions<PublishFarmSectionsResponse, PublishFarmSectionsError, Options<PublishFarmSectionsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await publishFarmSections({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registerQueryKey = (options: Options<RegisterData>) => [
    createQueryKey('register', options)
];

export const registerOptions = (options: Options<RegisterData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await register({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registerQueryKey(options)
    });
};

export const registerMutation = (options?: Partial<Options<RegisterData>>) => {
    const mutationOptions: UseMutationOptions<RegisterResponse, RegisterError, Options<RegisterData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await register({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOnboardingFarmQueryKey = (options?: Options) => [
    createQueryKey('getOnboardingFarm', options)
];

export const getOnboardingFarmOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOnboardingFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOnboardingFarmQueryKey(options)
    });
};

export const updateOnboardingFarmMutation = (options?: Partial<Options<UpdateOnboardingFarmData>>) => {
    const mutationOptions: UseMutationOptions<UpdateOnboardingFarmResponse, UpdateOnboardingFarmError, Options<UpdateOnboardingFarmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOnboardingFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOnboardingFieldsQueryKey = (options?: Options) => [
    createQueryKey('getOnboardingFields', options)
];

export const getOnboardingFieldsOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOnboardingFields({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOnboardingFieldsQueryKey(options)
    });
};

export const createOnboardingFieldQueryKey = (options: Options<CreateOnboardingFieldData>) => [
    createQueryKey('createOnboardingField', options)
];

export const createOnboardingFieldOptions = (options: Options<CreateOnboardingFieldData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOnboardingField({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOnboardingFieldQueryKey(options)
    });
};

export const createOnboardingFieldMutation = (options?: Partial<Options<CreateOnboardingFieldData>>) => {
    const mutationOptions: UseMutationOptions<CreateOnboardingFieldResponse, CreateOnboardingFieldError, Options<CreateOnboardingFieldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOnboardingField({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOnboardingFieldByIdQueryKey = (options: Options<GetOnboardingFieldByIdData>) => [
    createQueryKey('getOnboardingFieldById', options)
];

export const getOnboardingFieldByIdOptions = (options: Options<GetOnboardingFieldByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOnboardingFieldById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOnboardingFieldByIdQueryKey(options)
    });
};

export const updateOnboardingFieldMutation = (options?: Partial<Options<UpdateOnboardingFieldData>>) => {
    const mutationOptions: UseMutationOptions<UpdateOnboardingFieldResponse, UpdateOnboardingFieldError, Options<UpdateOnboardingFieldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOnboardingField({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteOnboardingFieldMutation = (options?: Partial<Options<DeleteOnboardingFieldData>>) => {
    const mutationOptions: UseMutationOptions<DeleteOnboardingFieldResponse, DeleteOnboardingFieldError, Options<DeleteOnboardingFieldData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteOnboardingField({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const findCurrentOnboardingFieldBoundaryQueryKey = (options: Options<FindCurrentOnboardingFieldBoundaryData>) => [
    createQueryKey('findCurrentOnboardingFieldBoundary', options)
];

export const findCurrentOnboardingFieldBoundaryOptions = (options: Options<FindCurrentOnboardingFieldBoundaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await findCurrentOnboardingFieldBoundary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findCurrentOnboardingFieldBoundaryQueryKey(options)
    });
};

export const createOnboardingAttachmentQueryKey = (options: Options<CreateOnboardingAttachmentData>) => [
    createQueryKey('createOnboardingAttachment', options)
];

export const createOnboardingAttachmentOptions = (options: Options<CreateOnboardingAttachmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOnboardingAttachment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOnboardingAttachmentQueryKey(options)
    });
};

export const createOnboardingAttachmentMutation = (options?: Partial<Options<CreateOnboardingAttachmentData>>) => {
    const mutationOptions: UseMutationOptions<CreateOnboardingAttachmentResponse, CreateOnboardingAttachmentError, Options<CreateOnboardingAttachmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOnboardingAttachment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const onboardingFieldBoundaryByLocationQueryKey = (options: Options<OnboardingFieldBoundaryByLocationData>) => [
    createQueryKey('onboardingFieldBoundaryByLocation', options)
];

export const onboardingFieldBoundaryByLocationOptions = (options: Options<OnboardingFieldBoundaryByLocationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onboardingFieldBoundaryByLocation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onboardingFieldBoundaryByLocationQueryKey(options)
    });
};

export const onboardingLowResBoundariesByBboxQueryKey = (options: Options<OnboardingLowResBoundariesByBboxData>) => [
    createQueryKey('onboardingLowResBoundariesByBbox', options)
];

export const onboardingLowResBoundariesByBboxOptions = (options: Options<OnboardingLowResBoundariesByBboxData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onboardingLowResBoundariesByBbox({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onboardingLowResBoundariesByBboxQueryKey(options)
    });
};

export const onboardingHighResBoundariesByDetectedIdQueryKey = (options: Options<OnboardingHighResBoundariesByDetectedIdData>) => [
    createQueryKey('onboardingHighResBoundariesByDetectedId', options)
];

export const onboardingHighResBoundariesByDetectedIdOptions = (options: Options<OnboardingHighResBoundariesByDetectedIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onboardingHighResBoundariesByDetectedId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: onboardingHighResBoundariesByDetectedIdQueryKey(options)
    });
};

export const resendEmailVerificationQueryKey = (options?: Options) => [
    createQueryKey('resendEmailVerification', options)
];

export const resendEmailVerificationOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendEmailVerification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendEmailVerificationQueryKey(options)
    });
};

export const resendEmailVerificationMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<ResendEmailVerificationResponse, ResendEmailVerificationError, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendEmailVerification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPublishedSystemContentQueryKey = (options: Options<GetPublishedSystemContentData>) => [
    createQueryKey('getPublishedSystemContent', options)
];

export const getPublishedSystemContentOptions = (options: Options<GetPublishedSystemContentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPublishedSystemContent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPublishedSystemContentQueryKey(options)
    });
};

export const updateSystemContentMutation = (options?: Partial<Options<UpdateSystemContentData>>) => {
    const mutationOptions: UseMutationOptions<UpdateSystemContentResponse, UpdateSystemContentError, Options<UpdateSystemContentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateSystemContent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDraftSystemContentQueryKey = (options: Options<GetDraftSystemContentData>) => [
    createQueryKey('getDraftSystemContent', options)
];

export const getDraftSystemContentOptions = (options: Options<GetDraftSystemContentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDraftSystemContent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDraftSystemContentQueryKey(options)
    });
};

export const publishSystemContentMutation = (options?: Partial<Options<PublishSystemContentData>>) => {
    const mutationOptions: UseMutationOptions<PublishSystemContentResponse, PublishSystemContentError, Options<PublishSystemContentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await publishSystemContent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTileQueryKey = (options: Options<GetTileData>) => [
    createQueryKey('getTile', options)
];

export const getTileOptions = (options: Options<GetTileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTileQueryKey(options)
    });
};

export const registerWithoutFarmQueryKey = (options?: Options) => [
    createQueryKey('registerWithoutFarm', options)
];

export const registerWithoutFarmOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await registerWithoutFarm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registerWithoutFarmQueryKey(options)
    });
};

export const registerWithoutFarmMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<RegisterWithoutFarmResponse, RegisterWithoutFarmError, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await registerWithoutFarm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccessTokenQueryKey = (options?: Options) => [
    createQueryKey('getAccessToken', options)
];

export const getAccessTokenOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAccessToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAccessTokenQueryKey(options)
    });
};

export const getUserByIdQueryKey = (options: Options<GetUserByIdData>) => [
    createQueryKey('getUserById', options)
];

export const getUserByIdOptions = (options: Options<GetUserByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserByIdQueryKey(options)
    });
};

export const editUserMutation = (options?: Partial<Options<EditUserData>>) => {
    const mutationOptions: UseMutationOptions<EditUserResponse, EditUserError, Options<EditUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await editUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>) => {
    const mutationOptions: UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllUsersQueryKey = (options?: Options<GetAllUsersData>) => [
    createQueryKey('getAllUsers', options)
];

export const getAllUsersOptions = (options?: Options<GetAllUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllUsersQueryKey(options)
    });
};

export const getAllUsersInfiniteQueryKey = (options?: Options<GetAllUsersData>): QueryKey<Options<GetAllUsersData>> => [
    createQueryKey('getAllUsers', options, true)
];

export const getAllUsersInfiniteOptions = (options?: Options<GetAllUsersData>) => {
    return infiniteQueryOptions<GetAllUsersResponse, GetAllUsersError, InfiniteData<GetAllUsersResponse>, QueryKey<Options<GetAllUsersData>>, unknown | Pick<QueryKey<Options<GetAllUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllUsersInfiniteQueryKey(options)
    });
};

export const createUserQueryKey = (options: Options<CreateUserData>) => [
    createQueryKey('createUser', options)
];

export const createUserOptions = (options: Options<CreateUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createUserQueryKey(options)
    });
};

export const createUserMutation = (options?: Partial<Options<CreateUserData>>) => {
    const mutationOptions: UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const changeUserPasswordQueryKey = (options: Options<ChangeUserPasswordData>) => [
    createQueryKey('changeUserPassword', options)
];

export const changeUserPasswordOptions = (options: Options<ChangeUserPasswordData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await changeUserPassword({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: changeUserPasswordQueryKey(options)
    });
};

export const changeUserPasswordMutation = (options?: Partial<Options<ChangeUserPasswordData>>) => {
    const mutationOptions: UseMutationOptions<ChangeUserPasswordResponse, ChangeUserPasswordError, Options<ChangeUserPasswordData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await changeUserPassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyUserQueryKey = (options?: Options) => [
    createQueryKey('getMyUser', options)
];

export const getMyUserOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyUserQueryKey(options)
    });
};